import http from 'hub-http/clients/apiClient';
import { useEffect, useState } from 'react';
import { createRpcClientV2 } from 'rpc-client-utils';
import { evaluateInAppRpc } from '../../__generated__/chirp/com/hubspot/purchase/motions/rpc/PurchaseMotionsEvaluationService';
import { isValidTalkToSalesPurchaseMotion } from '../utils/purchaseMotionTypeGuards';
const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
const isValidPurchaseMotion = motion => {
  return typeof motion === 'string';
};
export const usePurchaseMotionForAssignability = ({
  isAssignable,
  apiName
}) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const [purchaseMotion, setPurchaseMotion] = useState();
  useEffect(() => {
    if (isAssignable === undefined) {
      rpcClient.call(evaluateInAppRpc, {
        request: {
          productApiNames: [apiName],
          locations: ['TALK_TO_SALES_BUTTON']
        }
      }).then(response => {
        const chirpPurchaseMotions = response.purchaseMotionsMapping.productsByLocationString.TALK_TO_SALES_BUTTON.purchaseMotionsByProductApiName[apiName].purchaseMotions || [];
        const validPurchaseMotions = chirpPurchaseMotions.filter(isValidPurchaseMotion);
        const purchaseMotions = validPurchaseMotions.length > 0 ? validPurchaseMotions : ['TALK_TO_SALES_FALLBACK'];
        const evaluatedPurchaseMotion = purchaseMotions[0];
        if (!isValidTalkToSalesPurchaseMotion(evaluatedPurchaseMotion)) {
          setError(new Error(`invalid TTS PurchaseMotion: ${evaluatedPurchaseMotion.toString()}`));
        } else {
          setPurchaseMotion(evaluatedPurchaseMotion);
        }
      }).catch(e => {
        setError(e);
      }).finally(() => setLoading(false));
    } else {
      setPurchaseMotion(isAssignable ? 'TALK_TO_SALES' : 'TALK_TO_SALES_FALLBACK');
      setLoading(false);
    }
  }, [apiName, isAssignable]);
  return {
    loading,
    error,
    purchaseMotion
  };
};